import React, { useEffect, useState } from "react";
import "./TeliaPlayBenefits.less";
import { Button } from "@telia/teddy";
import { Modal, TextBlock, TextBlockUspList, LogoGrid as LogoGridType } from "../../../../../../models";
import { isRunningOnClientSide } from "../../../../../../shared/util";
import { InfoModal, InfoModalBody, InfoModalHeader } from "../../../../components";
import SubscriptionTextBlock from "../../../../components/components/molecules/SubscriptionTextBlock/SubscriptionTextBlock";
import LogoGrid from "../LogoGrid/LogoGrid";
import ModalSellingPoints from "../ModalSellingPoints/ModalSellingPoints";

const textBlock: TextBlock = {
    content: "",
    heading: "Med Telia Play får du:",
    uspList: [
        {
            icon: "play",
            title: '<p class="paragraph"><span style="font-family: TeliaSans, Helvetica, Arial, sans-serif; font-weight: 500;">Telia Play Box</span> — Strømme- og TV-boks med 4K</p>',
            __type: "USP",
            heading: "",
        },
        {
            icon: "remote-control",
            title: '<p class="paragraph">Opptak inkludert.</p>',
            __type: "USP",
            heading: "",
        },
        {
            icon: "tv",
            title: '<p class="paragraph">Tilgang til <span style="font-family: TeliaSans, Helvetica, Arial, sans-serif; font-weight: 500;">de største strømmetjenestene og kanaler</span> hele tiden, i ett abonnement.</p>',
            __type: "USP",
            heading: "",
        },
        {
            icon: "reverse",
            title: '<p class="paragraph">Bytt mellom <span style="font-family: TeliaSans, Helvetica, Arial, sans-serif; font-weight: 500;">strømmetjenester og kanaler</span> så ofte du vil rett fra fjernkontrollen.</p>',
            __type: "USP",
            heading: "",
        },
    ],
};

const TeliaPlayBenefits = (modal: Modal) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isClientSide, setIsClientSide] = useState(false);
    useEffect(() => {
        if (isRunningOnClientSide()) {
            setIsClientSide(true);
        }
    }, []);

    return (
        <div className="telia-play-benefits">
            <SubscriptionTextBlock headingSize="xs" headingTag="h3" key={textBlock.heading} textBlock={textBlock} />
            <div className="telia-play-benefits__logo-container">
                <div className="telia-play-benefits__logo">
                    <img
                        width={63}
                        height={34}
                        alt="Netflix logo"
                        src="/shop/assets/img-static/campaign/netflix-logo.svg"
                    />
                </div>
                <div className="telia-play-benefits__logo">
                    <img
                        height={34}
                        width={55}
                        alt="Max Logo"
                        src="/shop/assets/img-static/campaign/hbo-Max-logo-white.svg"
                    />
                </div>
                <div className="telia-play-benefits__logo">
                    <img
                        width={60}
                        height={34}
                        alt="Viaplay logo"
                        src="/shop/assets/img-static/campaign/viaplay-on-black-background.svg"
                    />
                </div>
                <div className="telia-play-benefits__logo">
                    <img
                        width={50}
                        height={34}
                        alt="Tv 2 Play logo"
                        src="/shop/assets/img-static/campaign/tv2-logo.svg"
                    />
                </div>
                <div className="telia-play-benefits__logo">
                    <img
                        height={34}
                        width={60}
                        alt="Sky showtime logo"
                        src="/shop/assets/img-static/campaign/skyshowtime-logo.svg"
                    />
                </div>
            </div>
            <div className="telia-play-benefits__link-container">
                <Button variant="text-underline" onClick={() => setIsModalOpen(true)}>
                    Les mer om Telia Play
                </Button>
            </div>

            {isClientSide && (
                <InfoModal
                    open={isModalOpen}
                    setOpen={() => setIsModalOpen(false)}
                    ariaLabelledBy="Telia play fordeler"
                    className="telia-play-benefits__info-modal"
                >
                    <InfoModalHeader headerText={modal.heading} ingress={modal.ingress} />
                    <InfoModalBody>
                        <div className="telia-play-benefits__modal">
                            {modal.blocks
                                ?.filter((block): block is TextBlockUspList => block.__type === "USPList")
                                .map((block, index) => (
                                    <ModalSellingPoints key={index} sellingPoints={block.sellingPoints} />
                                ))}
                            <div>
                                {modal.blocks
                                    ?.filter((block): block is LogoGridType => block.__type === "LogoGrid")
                                    .map((block, index) => (
                                        <div key={index} className="telia-play-benefits__logo-grid">
                                            <LogoGrid {...block} />
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <Button
                            className="telia-play-benefits__modal-close-button"
                            variant="text-underline"
                            onClick={() => setIsModalOpen(false)}
                        >
                            Lukk
                        </Button>
                    </InfoModalBody>
                </InfoModal>
            )}
        </div>
    );
};

export default TeliaPlayBenefits;
